import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../app/store';
import Loading from '../../components/loading/Loading';

const PrivateRoute: React.FC = () => {
	const { isAuth, authChecked, user } = useSelector((state: RootState) => state.auth);

	if (!authChecked) {
		return <Loading />;
	}

	return isAuth && user?.role === 'ADMIN' ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoute;
